// // consol('sandeep')
 import swal from "sweetalert";
getDate();
        

export function getDate()
{
    var inputs = document.getElementsByTagName('input');
  
    // // consol(inputs[1])
    // // consol(inputs);
    var today = new Date(Date.now());
   var dd = today.getDate();
   var mm = today.getMonth()+1; //January is 0!
   var yyyy = today.getFullYear();
    if(dd<10){
           dd='0'+dd
       } 
       if(mm<10){
           mm='0'+mm
       } 
   
   today = yyyy+'-'+mm+'-'+dd;
   for(var i = 0; i < inputs.length; i++) {
    if(inputs[i].type.toLowerCase() == 'date') {
        
        //inputs[i].setAttribute('value',inputs[i].getAttribute('defaultValue')) 
        inputs[0].removeAttribute('value')
       inputs[0].setAttribute('defaultValue',today)
       
        inputs[0].setAttribute('value',today)
        // // consol(inputs[0].getAttribute('value')+"-----------------------------------------------------")
       //document.getElementsByTagName('input')[i].setAttribute('value','2020-04-29')
    }
    if(inputs[i].type.toLowerCase() == 'time') {
       // inputs[i].setAttribute('value',inputs[i].getAttribute('defaultValue')) 
       inputs[i].setAttribute('value',getTime())
        inputs[i].setAttribute('defaultValue',getTime())
   }
}
// // consol(today)
// // consol(getTime())
//// consol(inputs[0].getAttribute('value')+"-----------------------------------------------------")
}

export function validateHoursToEnterPreviousData(company,TimeToCompare){
    let result = false;
    if (company && company.IsDataEntryRestrictionEnabled) {
      let now = new Date();
      now = new Date(now.setHours(now.getHours() - company.HoursToEnterPreviousData));
      if (TimeToCompare < now) {
        result = true;
      }
    }
    return result;
  }




function getTime(){
    
      let Time = new Date();
      return (
        (Time.getHours() < 10 ? "0" : "") +
        Time.getHours() +
        ":" +
        (Time.getMinutes() < 10 ? "0" : "") +
        Time.getMinutes()
      );
  
  };

  function confirmDangerousAction(doAction,messages) {
    swal({
      title: "Are you sure?",
      text: messages,
      icon: "warning",
      buttons: {
        cancel: {
          text: "No, cancel",
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: "Yes, do it",
          closeModal: false, // keep open until we finish
        },
      },
      dangerMode: true,
    }).then(async (willDo) => {
      if (!willDo) {
        return swal("Cancelled", "Your data is safe 🙂", "info");
      }
      try {
        await doAction(); // your async logic
        swal("Done!", "The action was completed successfully.", "success");
      } catch (err) {
        swal("Failed", err?.message || "Something went wrong.", "error");
      }
    });
  }

function stripInternalKeys(value) {
  if (Array.isArray(value)) {
    return value.map(stripInternalKeys);
  }
  if (value && typeof value === 'object') {
    const cleaned = {};
    Object.keys(value).forEach((k) => {
      if (k === '_id' || k === '__v') return;
      cleaned[k] = stripInternalKeys(value[k]);
    });
    return cleaned;
  }
  return value;
}

function formatDisplayValue(value) {
  if (Array.isArray(value)) {
    if (value.every((item) => item === null || typeof item !== 'object')) {
      return value.join(', ');
    }
    return stripInternalKeys(value);
  }
  if (value && typeof value === 'object') {
    return stripInternalKeys(value);
  }
  return value === undefined ? null : value;
}

function isEqualValue(a, b) {
  try {
    return JSON.stringify(stripInternalKeys(a)) === JSON.stringify(stripInternalKeys(b));
  } catch (e) {
    return a === b;
  }
}

function getArrayChanges(oldArr = [], newArr = [], parentKey) {
  const changes = {};
  const maxLen = Math.max(oldArr.length, newArr.length);

  for (let i = 0; i < maxLen; i++) {
    const oldItem = oldArr[i];
    const newItem = newArr[i];
    const label = `${parentKey} ${i + 1}`;

    if (oldItem === undefined) {
      changes[`${label} (added)`] = { oldValue: null, newValue: formatDisplayValue(newItem) };
      continue;
    }
    if (newItem === undefined) {
      changes[`${label} (removed)`] = { oldValue: formatDisplayValue(oldItem), newValue: null };
      continue;
    }

    if (oldItem && newItem && typeof oldItem === 'object' && typeof newItem === 'object' && !Array.isArray(oldItem) && !Array.isArray(newItem)) {
      const subKeys = new Set([...Object.keys(oldItem), ...Object.keys(newItem)]);
      subKeys.forEach((sk) => {
        if (sk === '_id' || sk === '__v') return;
        if (!isEqualValue(oldItem[sk], newItem[sk])) {
          changes[`${label} - ${sk}`] = {
            oldValue: formatDisplayValue(oldItem[sk]),
            newValue: formatDisplayValue(newItem[sk])
          };
        }
      });
    } else if (!isEqualValue(oldItem, newItem)) {
      changes[label] = { oldValue: formatDisplayValue(oldItem), newValue: formatDisplayValue(newItem) };
    }
  }

  return changes;
}

function getChangedFields(oldObj = {}, newObj = {}) {
  const ignoreKeys = ['_id', '__v', 'createdAt', 'updatedAt', 'modified', 'Enable', 'tokens', 'NumberOfOperations'];
  const changes = {};
  const keys = new Set([
    ...Object.keys(oldObj || {}),
    ...Object.keys(newObj || {})
  ]);

  keys.forEach((key) => {
    if (ignoreKeys.includes(key)) return;
    const oldValue = oldObj ? oldObj[key] : undefined;
    const newValue = newObj ? newObj[key] : undefined;

    if (Array.isArray(oldValue) || Array.isArray(newValue)) {
      const isObjectArray =
        (Array.isArray(oldValue) && oldValue.some((v) => v && typeof v === 'object')) ||
        (Array.isArray(newValue) && newValue.some((v) => v && typeof v === 'object'));

      if (isObjectArray) {
        Object.assign(changes, getArrayChanges(oldValue || [], newValue || [], key));
        return;
      }
    }

    if (!isEqualValue(oldValue, newValue)) {
      changes[key] = {
        oldValue: formatDisplayValue(oldValue),
        newValue: formatDisplayValue(newValue)
      };
    }
  });

  return changes;
}

// Job entry default: the operation's DefaultPartsPerCycle, limited by the selected tool's capacity.
export function getDefaultPartsPerCycle(operation, tool) {
  const toolValue = Number(tool && tool.PartsPerCycle);
  const defaultValue = Number(operation && operation.DefaultPartsPerCycle);
  const hasToolValue = !isNaN(toolValue) && toolValue > 0;
  const hasDefaultValue = !isNaN(defaultValue) && defaultValue > 0;
  if (hasToolValue && hasDefaultValue) return Math.min(toolValue, defaultValue);
  if (hasToolValue) return toolValue;
  if (hasDefaultValue) return defaultValue;
  return operation ? operation.PartsPerCycle : undefined;
}

/**
 * Pulls a human readable message out of an axios error.
 *
 * Reading `err.response.data.message` directly is unsafe for two reasons:
 * `err.response` is undefined for network/timeout/CORS failures (which throws a
 * TypeError inside the catch block), and the API does not use a single error
 * shape. Errors arrive as `{ message }`, as `{ error: { message } }` from the
 * global error handler, as a bare string, or as `{}` when a raw Error instance
 * was serialized. Every one of those used to surface in the UI as "undefined".
 */
export function getApiErrorMessage(err, fallback = "Something went wrong. Please try again.") {
  if (!err) return fallback;

  // No response at all: request never reached the server or was aborted.
  if (!err.response) {
    if (err.code === "ECONNABORTED") return "The request timed out. Please try again.";
    return err.message || fallback;
  }

  const data = err.response.data;

  if (typeof data === "string" && data.trim()) return data.trim();

  if (data && typeof data === "object") {
    if (typeof data.message === "string" && data.message.trim()) return data.message.trim();
    if (data.error) {
      if (typeof data.error === "string" && data.error.trim()) return data.error.trim();
      if (typeof data.error.message === "string" && data.error.message.trim()) {
        return data.error.message.trim();
      }
    }
    if (Array.isArray(data.errors) && data.errors.length) {
      const joined = data.errors
        .map((e) => (typeof e === "string" ? e : e && e.message))
        .filter(Boolean)
        .join("; ");
      if (joined) return joined;
    }
  }

  // Body carried nothing usable (e.g. a serialized Error became `{}`).
  if (err.response.status) return `${fallback} (Error ${err.response.status})`;
  return fallback;
}

export default{
    getDate,
    confirmDangerousAction,
    getChangedFields,
    getDefaultPartsPerCycle,
    getApiErrorMessage
}

